/**
*  UI-REFACTORED
*    FROM --> ./legacy-web/src/main/js/awardFinder/resources/js/mainUtilities.js
*    TO   --> ./webapps/homepage-web/src/main/assets/js/home/award-finder/main-utilities.js
**/

/* utilities common to several pages */

//Mobile detection using mediaqueries in responsive classes on reponsive.css
var $is_mobile = false;
var $is_tablet = false;
if( $('.visible-phone').css('display') != 'none' ) {
	$is_mobile = true;
}
else if( $('.visible-tablet').css('display') != 'none' ) {
	$is_tablet = true;
}
// now i can use $is_mobile and $is_tablet to run javascript conditionally for mobile/tablet devices

var MainUtilities = {};

MainUtilities = (function() {
	
	
	/**
	 * function
	 */
	var initMain = function() {
		// do stuff
	};
	
	/**
	 * put functions to be exposed as public here.
	 * If not listed here, function is private
	 */
	return {
		initMain: initMain
	};
	
}());
	